import { render, staticRenderFns } from "./PhotoSlider.vue?vue&type=template&id=4fdd0596&scoped=true&"
import script from "./PhotoSlider.vue?vue&type=script&lang=js&"
export * from "./PhotoSlider.vue?vue&type=script&lang=js&"
import style0 from "./PhotoSlider.vue?vue&type=style&index=0&id=4fdd0596&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdd0596",
  null
  
)

export default component.exports